module.exports = __webpack_public_path__ + "img/location-black.97459bdc.svg";